import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { queryCommonFlags } from "@/api/constants";
import { debounce } from "lodash";
import { fetchCompoundsLookups } from "../../api/property-management";

const useCompoundsFilterOptions = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = useMemo(
    () =>
      debounce((value) => {
        setSearchTerm(value);
      }, 300),
    []
  );

  const {
    data: compounds,
    error: compoundsError,
    isLoading: compoundsLoading,
    refetch: refetchCompounds,
  } = useQuery({
    queryKey: ["compounds", searchTerm],
    queryFn: () => fetchCompoundsLookups(searchTerm),
    ...queryCommonFlags,
    staleTime: 60000,
  });

  return {
    refetchCompounds,
    compounds: compounds?.data,
    compoundsError,
    compoundsLoading,
    handleSearchChange,
    searchTerm,
  };
};

export default useCompoundsFilterOptions;
